import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUserEdit_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUserEdit_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  GetRoles: any[];
  GetRoles_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  UpdateUserName: string;
  UpdateUserName_dummy: string;
  ChangeUserDetail: number;
  ChangeUserDetail_dummy: number;
  SWUpdateUserData: number;
  SWUpdateUserData_dummy: number;
  EnableUser: any;
  EnableUser_dummy: any;
  DisableUser: any;
  DisableUser_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  FNRollerParcala: any[];
  FNRollerParcala_dummy: any[];
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  ForEach3: FNRollerParcala;
  ForEach3_dummy: FNRollerParcala;
  Notify: boolean;
  Notify_dummy: boolean;
}

export class UserEdit_ScreenBase extends React.PureComponent<
  IUserEdit_ScreenProps,
  any
> {
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "7d8f737e-d870-4982-94f7-10fdd117e343",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 28964, PropertyName: "value", Value: "Kullanıcı Düzenle" },
        { Id: 215629, PropertyName: "value", Value: "Kullanıcı Adı Soyadı" },
        {
          Id: 689698,
          PropertyName: "placeholder",
          Value: "Kullanıcı Adı Soyadı",
        },
        { Id: 692213, PropertyName: "value", Value: "Kullanıcı E-Posta" },
        { Id: 701223, PropertyName: "placeholder", Value: "ornek@mail.com" },
        { Id: 277050, PropertyName: "value", Value: "Kullanıcı Rolu" },
        {
          Id: 260463,
          PropertyName: "placeholder",
          Value: "Rolları Seçiniz...",
        },
        { Id: 64393, PropertyName: "label", Value: "Aktiflik Durumu" },
        { Id: 513456, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach3: any[];

  constructor(props) {
    super(props);
    this.useredit_689698_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserByUsername: [],
      GetRoles: [],
      GoBack: "",
      UpdateUserName: "",
      ChangeUserDetail: 0,
      SWUpdateUserData: 0,
      IfThenElse: false,
      FNRollerParcala: [],
      ForEach: false,
      Notify: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("useredit", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UserEditPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("useredit", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("useredit", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UserEditPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      useredit_689698_value:
        this.state.GetUserByUsername?.at?.(0)?.firstName ?? undefined,
      useredit_701223_value:
        this.state.GetUserByUsername?.at?.(0)?.userName ?? undefined,
      useredit_64393_checked:
        this.state.GetUserByUsername?.at?.(0)?.isDeleted ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UserEditPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Username ?? this.props.screenInputs.username,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UserEdit/UserEditPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    formVars.useredit_689698_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].firstName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].firstName
        : null
    );
    formVars.useredit_701223_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].userName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].userName
        : null
    );
    formVars.useredit_64393_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].isDeleted
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].isDeleted
        : null
    );
    stateVars.GetRoles = result?.data.getRoles;

    formVars.useredit_260463_options = stateVars.GetRoles;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UserEditPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UserEditPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.useredit_689698_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].firstName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].firstName
        : null
    );

    formVars.useredit_701223_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].userName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].userName
        : null
    );

    stateVars.dataSource_260463 = stateVars.GetRoles ?? this.state.GetRoles;
    stateVars.dataSource_260463 = stateVars.GetRoles ?? this.state.GetRoles;
    formVars.useredit_64393_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].isDeleted
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].isDeleted
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UserEditComponent_480564_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UserEditComponent_513456_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "useredit_701223_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].userName
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].userName
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_701223_value",
            "value",
            "",
            "",
            ""
          )
        )
      )
    ) {
      KuikaAppManager.showSpinner(this);
      KuikaAppManager.increaseServerRequestCount();

      stateVars.UpdateUserName = await ReactSystemFunctions.updateUserName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].userName
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].userName
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_701223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        false,
        ReactSystemFunctions.convertToTypeByName("", "string")
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UserEditComponent_513456_onClick1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UserEditComponent_513456_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UserEditComponent_513456_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "useredit_701223_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FullName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_689698_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      LastName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_689698_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_701223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      AdSoyad_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_689698_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Email_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_701223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      isAktif_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_64393_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      KUserID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UserEdit/UserEditComponent_513456_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChangeUserDetail = result?.data.changeUserDetail;
    stateVars.SWUpdateUserData = result?.data.swUpdateUserData;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UserEditComponent_513456_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UserEditComponent_513456_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "useredit_701223_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.EnableUser = await ReactSystemFunctions.enableUser(
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UserEditComponent_513456_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "useredit_701223_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.DisableUser = await ReactSystemFunctions.disableUser(
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UserEditComponent_513456_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_64393_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred = await this.UserEditComponent_513456_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.UserEditComponent_513456_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UserEditComponent_513456_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UserEditComponent_513456_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Roller_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "useredit_260463_value",
            "value",
            "GetRoles",
            "id",
            "name"
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UserEdit/UserEditComponent_513456_onClick3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.FNRollerParcala = result?.data.fnRollerParcala;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UserEditComponent_513456_onClick4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UserEditComponent_513456_onClick_foreach4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "useredit_701223_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.value(this, this.ForEach3?.roleName),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "useredit_701223_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UserEditComponent_513456_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.FNRollerParcala)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.FNRollerParcala
      )) {
        this.ForEach3 = item;
        await this.UserEditComponent_513456_onClick_foreach4();
      }
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "5452c66d_b5c3_7863_d9ba_0a3b1c7bdcae_notify",
        this.defaultML,
        "Kullanıcı bilgiler başarıyla düzenlendi !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UserEditPageInit();
    }
  }
}
